export default "__VITE_ASSET__BzSTTaGp__"